/******/ var __webpack_modules__ = ({

/***/ 2659:
/***/ (function() {

var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _TabsComponent_instances, _TabsComponent_abort, _TabsComponent_tabs_get, _TabsComponent_panels_get;
class TabsComponent extends HTMLElement {
    constructor() {
        super(...arguments);
        _TabsComponent_instances.add(this);
        _TabsComponent_abort.set(this, new AbortController());
    }
    connectedCallback() {
        var _a;
        __classPrivateFieldSet(this, _TabsComponent_abort, new AbortController(), "f");
        const { signal } = __classPrivateFieldGet(this, _TabsComponent_abort, "f");
        if (!__classPrivateFieldGet(this, _TabsComponent_instances, "a", _TabsComponent_tabs_get).length || !__classPrivateFieldGet(this, _TabsComponent_instances, "a", _TabsComponent_panels_get).length)
            return;
        const tabs = __classPrivateFieldGet(this, _TabsComponent_instances, "a", _TabsComponent_tabs_get);
        const panels = __classPrivateFieldGet(this, _TabsComponent_instances, "a", _TabsComponent_panels_get);
        tabs.forEach((tab) => {
            var _a;
            if ((_a = tab.textContent) === null || _a === void 0 ? void 0 : _a.trim())
                return;
            const panelId = tab.getAttribute('aria-controls');
            const panel = panelId ? this.querySelector(`#${CSS.escape(panelId)}`) : null;
            const label = panel === null || panel === void 0 ? void 0 : panel.getAttribute('data-tab-label');
            if (label)
                tab.textContent = label;
        });
        const initialTab = (_a = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true')) !== null && _a !== void 0 ? _a : tabs[0];
        const setActiveTab = (tab, focus = true) => {
            const panelId = tab.getAttribute('aria-controls');
            const activePanel = panelId ? this.querySelector(`#${CSS.escape(panelId)}`) : null;
            tabs.forEach((item) => {
                const isActive = item === tab;
                item.setAttribute('aria-selected', isActive ? 'true' : 'false');
                item.tabIndex = isActive ? 0 : -1;
            });
            panels.forEach((panel) => {
                const isActive = panel === activePanel;
                if (panel instanceof HTMLDetailsElement) {
                    panel.open = isActive;
                }
                if (isActive) {
                    panel.removeAttribute('hidden');
                }
                else {
                    panel.setAttribute('hidden', '');
                }
            });
            if (focus)
                tab.focus({ preventScroll: true });
        };
        const getNextIndex = (key, currentIndex) => {
            switch (key) {
                case 'ArrowRight':
                    return (currentIndex + 1) % tabs.length;
                case 'ArrowLeft':
                    return (currentIndex - 1 + tabs.length) % tabs.length;
                case 'Home':
                    return 0;
                case 'End':
                    return tabs.length - 1;
                default:
                    return currentIndex;
            }
        };
        tabs.forEach((tab, index) => {
            tab.tabIndex = tab === initialTab ? 0 : -1;
            tab.addEventListener('click', (event) => {
                event.preventDefault();
                setActiveTab(tab, false);
            }, { signal });
            tab.addEventListener('keydown', (event) => {
                const key = event.key;
                const isMoveKey = key === 'ArrowRight' || key === 'ArrowLeft' || key === 'Home' || key === 'End';
                const isSelectKey = key === 'Enter' || key === ' ';
                if (!isMoveKey && !isSelectKey)
                    return;
                event.preventDefault();
                if (isMoveKey) {
                    setActiveTab(tabs[getNextIndex(key, index)]);
                    return;
                }
                setActiveTab(tab);
            }, { signal });
        });
        setActiveTab(initialTab, false);
    }
    disconnectedCallback() {
        __classPrivateFieldGet(this, _TabsComponent_abort, "f").abort();
    }
}
_TabsComponent_abort = new WeakMap(), _TabsComponent_instances = new WeakSet(), _TabsComponent_tabs_get = function _TabsComponent_tabs_get() {
    return Array.from(this.querySelectorAll('[data-tabs-tab]'));
}, _TabsComponent_panels_get = function _TabsComponent_panels_get() {
    return Array.from(this.querySelectorAll('[data-tabs-panel]'));
};
if (!customElements.get('tabs-component')) {
    customElements.define('tabs-component', TabsComponent);
}


/***/ })

/******/ });
/************************************************************************/
/******/ 
/******/ // startup
/******/ // Load entry module and return exports
/******/ // This entry module is referenced by other modules so it can't be inlined
/******/ var __webpack_exports__ = {};
/******/ __webpack_modules__[2659].call(__webpack_exports__);
/******/ export { __webpack_exports__ as default };
/******/ 
